class LanguageService {
  constructor() {
    this.STORAGE_KEY = 'scoreo_preferred_language';
    this.DEFAULT_LANGUAGE = 'cs';
  }

  // Get stored language preference or return default (Czech)
  getStoredLanguage() {
    try {
      const stored = localStorage.getItem(this.STORAGE_KEY);
      return stored && this.isValidLanguage(stored) ? stored : this.DEFAULT_LANGUAGE;
    } catch (error) {
      console.warn('Failed to read language preference from localStorage:', error);
      return this.DEFAULT_LANGUAGE;
    }
  }

  // Save language preference
  setStoredLanguage(language) {
    try {
      if (this.isValidLanguage(language)) {
        localStorage.setItem(this.STORAGE_KEY, language);
      }
    } catch (error) {
      console.warn('Failed to save language preference to localStorage:', error);
    }
  }

  // Validate if language is supported
  isValidLanguage(lang) {
    const supportedLanguages = ['cs', 'en'];
    return supportedLanguages.includes(lang);
  }

  // Initialize language (Czech default for new users)
  initializeLanguage() {
    // Always check localStorage first, default to Czech if nothing stored
    const stored = this.getStoredLanguage();
    return stored || this.DEFAULT_LANGUAGE;
  }

  // Change language and persist it
  changeLanguageAndPersist(i18n, newLanguage) {
    if (!this.isValidLanguage(newLanguage)) {
      console.warn(`Unsupported language: ${newLanguage}`);
      return false;
    }

    try {
      // Update i18next
      i18n.changeLanguage(newLanguage);
      
      // Persist to localStorage
      this.setStoredLanguage(newLanguage);
      
      return true;
    } catch (error) {
      console.error('Failed to change language:', error);
      return false;
    }
  }
}

const languageService = new LanguageService();
export default languageService;